import { render, staticRenderFns } from "./create-special.vue?vue&type=template&id=7c1a0b72"
import script from "./create-special.vue?vue&type=script&lang=js"
export * from "./create-special.vue?vue&type=script&lang=js"
import style0 from "./create-special.vue?vue&type=style&index=0&id=7c1a0b72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports